<template>
  <transition name="bounce">
		<span class="confirm-box" @click.stop v-show="show">
			<span class="confirm-content" v-html="content"></span>
			<span class="confirm-options">
				<a
            v-if="cancelTrigger"
            class="comp-control-cancel"
            @click.stop="cancel"
        >
					{{cancelTrigger}}
				</a>
				<i class="divider" v-if="cancelTrigger"></i>
				<span v-for="(action, action_key) in actions" class="comp-control-action">
					<a @click.stop="doAction(action_key)">{{ action.label }}</a>
					<i class="divider"></i>
				</span>
				<a class="comp-control-confirm" @click.stop="doConfirm">{{ button }}</a>
			</span>
		</span>
  </transition>
</template>

<script>

export default {
  name: "ConfirmBox",
  props: {
    content: {type: String, required: true},
    button: {type: String, required: true},
    show: {type: Boolean, required: true},
    actions: {},
    cancelTrigger: {default: 'Cancel'}
  },
  data() {
    return {
      no_pointer_events: false
    };
  },
  methods: {
    doConfirm() {
      this.no_pointer_events = true;
      setTimeout(() => {
        this.$dispatch('confirm');
      }, 200);
    },
    doAction( action_key ){
      this.no_pointer_events = true;
      setTimeout(() => {
        this.$dispatch('actionFired', action_key)
      }, 200);
    },
    cancel() {
      this.no_pointer_events = true;
      setTimeout(() => {
        this.$dispatch('cancel');
      }, 200);
    },
  },
  watch: {
    show() {
      if( this.show === true ){
        this.no_pointer_events = false;
        setTimeout(()=>{
          document.querySelector('body').addEventListener('click', this.cancel);
        }, 500)
      }else{
        document.querySelector('body').removeEventListener('click', this.cancel);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.no-pointer-events {
  pointer-events: none;
}

.confirm-box {
  text-align: left;
  cursor: initial;
  position: absolute;
  top: -100%;
  right: calc(100% + 20px);
  background: white;
  white-space: nowrap;
  padding: 10px;
  border: 4px solid #eee;
  font-family: system-ui, sans-serif;
  z-index: 99;
  color: #333;
  box-shadow: 0 2px 5px rgba(black,.25) !important;

  .confirm-content {
    display: block;
    font-size: .8rem;
    margin: 0;
    min-width: 300px;
    white-space: normal;
  }

  a {
    display: inline-block;
    margin-top: .5rem;
    cursor: pointer;
    font-size: .8rem !important;
  }

  i.divider::after {
    content:" | ";
    font-style:normal;
    opacity:.2;
  }

  .comp-control-action:last-of-type .divider {
    display:none;
  }
}

  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .3s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
